import { useCountry } from '@shared/selectors/globalSelectors';
import PhoneInput2 from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

export const PhoneInputComponent = ({ 
  value, 
  onChange, 
  placeholder, 
  className 
}: {
  value?: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}) => {
  return (
    <PhoneInput2
      country={'us'} // Default country
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      inputClass={className}
      containerClass="phone-input-container"
      inputStyle={{
        width: '100%',
        height: '40px',
        fontSize: '14px',
        border: '1px solid #d1d5db',
        borderRadius: '8px',
        paddingLeft: '48px',
      }}
      buttonStyle={{
        border: '1px solid #d1d5db',
        borderRadius: '8px 0 0 8px',
        backgroundColor: 'white',
      }}
      dropdownStyle={{
        borderRadius: '8px',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
      }}
    />
  );
};